/*
Copyright© Celligence International, LLC - 2024

This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained

access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import Styles from '../../css/LoanInformation.module.css';
import EnvelopeWithBox from '../EnvelopeWithBox';
import { useLoanInformationContext } from '../../contexts/LoanInformationContext';
import { getTimestampAsDate } from '../../common/UtilityFunctions';
import useQidList from '../../common/hooks/useQidList';

const InvestorDetails = () => {
  const { servicingData, handleServicingChange } = useLoanInformationContext();
  const formatCodeWithDesc = (code?: string | number | null, desc?: string | null) => {
    const left = `${code ?? ''}`.trim();
    const right = `${desc ?? ''}`.trim();
    if (!left && !right) return '';
    if (!left) return right;
    if (!right) return left;
    return `${left} - ${right}`;
  };
  const { qid: investorCodeQid, loadingQid } = useQidList('MASZ_CD.029');
  return (
    <EnvelopeWithBox blockName='Investor Details'>
      <div className={Styles.loanInfoTable}>
        <div className={Styles.leftColumn}>
          <table className={Styles.loanInfoTableSection}>
            <tbody>
              <tr>
                <th>Investor Code:</th>
                <td>
                  <select
                    name={'Investor Code'}
                    value={servicingData?.investorCode}
                    onChange={(e) => handleServicingChange('edit', 'investorCode', e.target.value)}
                  >
                    <option value='' disabled>
                      -- Select an Option --
                    </option>
                    {investorCodeQid.map((opt, i) => (
                      <option key={i} value={opt.code}>
                        {opt.code} - {opt.description}
                      </option>
                    ))}
                  </select>
                </td>
              </tr>
              <tr>
                <th>Investor Number:</th>
                <td>
                  <input
                    type='text'
                    maxLength={16}
                    value={servicingData?.theirLoanNo ? servicingData?.theirLoanNo : ''}
                    onChange={(e) => handleServicingChange('edit', 'theirLoanNo', e.target.value)}
                  />
                </td>
              </tr>
              <tr>
                <th>Group Code:</th>
                <td>
                  <input
                    type='text'
                    maxLength={3}
                    value={servicingData?.investorGroupCode ? servicingData?.investorGroupCode : ''}
                    onChange={(e) => handleServicingChange('edit', 'investorGroupCode', e.target.value)}
                    placeholder='Please input the Investor Group code'
                  />
                </td>
              </tr>
              <tr>
                <th>Pool:</th>
                <td>{servicingData?.theirCommitNo ? servicingData?.theirCommitNo : ''}</td>
              </tr>
              <tr>
                <th>Securitized Paid To Date: </th>
                <td>{servicingData?.ownerXferDate ? getTimestampAsDate(servicingData?.ownerXferDate) : ''}</td>
              </tr>
            </tbody>
            <tr>
              <td colSpan={2} style={{ height: '20px' }}></td>
            </tr>
          </table>
        </div>
      </div>
    </EnvelopeWithBox>
  );
};

export default InvestorDetails;
